import React from 'react';
import { ExternalLink, Sparkles } from 'lucide-react';

export const ChatMessage = ({ message, partnerLinks, onPartnerClick }) => {
  const isUser = message.role === 'user';
  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`} data-testid={`chat-message-${message.role}`}>
      <div className={`max-w-[85%] space-y-2 ${isUser ? 'items-end' : 'items-start'}`}>
        <div className={`rounded-2xl px-4 py-2.5 text-sm leading-relaxed whitespace-pre-wrap break-words ${
          isUser ? 'bg-blue-600 text-white rounded-br-md' : message.failed ? 'bg-red-50 text-red-700 border border-red-100 rounded-bl-md' : 'bg-slate-100 text-slate-800 rounded-bl-md'
        }`}>
          {message.content || (message.streaming && <span className="inline-flex gap-1 py-1" data-testid="chat-typing"><i className="h-1.5 w-1.5 rounded-full bg-slate-400 animate-bounce" /><i className="h-1.5 w-1.5 rounded-full bg-slate-400 animate-bounce [animation-delay:120ms]" /><i className="h-1.5 w-1.5 rounded-full bg-slate-400 animate-bounce [animation-delay:240ms]" /></span>)}
        </div>
        {!isUser && message.partners?.length > 0 && (
          <div className="flex flex-wrap gap-2" data-testid="chat-partner-ctas">
            {message.partners.map((name) => partnerLinks[name] && (
              <button
                key={name}
                type="button"
                data-testid="chat-partner-quote-btn"
                onClick={() => onPartnerClick(name, partnerLinks[name])}
                className="inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-blue-600 to-blue-500 text-white text-xs font-semibold px-3.5 py-2 shadow-md shadow-blue-500/30 hover:from-blue-500 hover:to-blue-400 hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
              >
                <Sparkles className="h-3.5 w-3.5" /> Cotizar con {name} <ExternalLink className="h-3 w-3" />
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
